// Desktop placeholder shown in the main content area when no word is open
// (route `/words`). On mobile this route renders the search list instead, so
// this component is effectively desktop-only (hidden by the layout's CSS).

/** "Nothing selected" affordance for the master-detail content area. */
export function WordsEmptyState() {
  return (
    <div className="words-content-empty">
      <span className="material-symbols-rounded words-content-empty__icon" aria-hidden="true">
        menu_book
      </span>
      <p className="words-content-empty__text">Taper un mot dans la barre de recherche</p>
    </div>
  );
}
